import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function HeartDisorderDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Heart Disorder Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please confirm the exact diagnosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.subQuestions.exactDiagnosis}</p>

                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosis.subQuestions.dateOfDiagnosis)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm details of symptoms:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.symptoms.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question>Nature of Symptoms</Question>
                                <p>{questions.symptoms.subQuestions.natureOf}</p>
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question>Frequency of Symptoms:</Question>
                                <p>{questions.symptoms.subQuestions.frequency}</p>
                            </QuestionWrapper>

                            <QuestionWrapper number='c'>
                                <Question>Duration of Symptoms:</Question>
                                <p>{questions.symptoms.subQuestions.duration}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please confirm whether the condition is Acute/Chronic:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.classification.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question
                                    answer={questions.classification.subQuestions.acute ? 'Yes' : 'No'}
                                >
                                    Acute:
                                </Question>
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question
                                    answer={questions.classification.subQuestions.chronic ? 'Yes' : 'No'}
                                >
                                    Chronic:
                                </Question>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide the results and dates of any relevant investigations e.g., ECHO, MRI etc:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Please provide details of any treatment to include Surgery, Ablation, Medications, Other:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.surgery ? 'Yes' : 'No'}
                                >
                                    Surgery:
                                </Question>

                                {questions.treatmentProvided.subQuestions.surgery === true && (
                                    <>
                                        <OutputDetails
                                            details={questions.treatmentProvided.subQuestions.surgeryDetails}
                                        />
                                    </>
                                )}
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.ablation ? 'Yes' : 'No'}
                                >
                                    Ablation:
                                </Question>

                                {questions.treatmentProvided.subQuestions.ablation === true && (
                                    <>
                                        <OutputDetails
                                            details={questions.treatmentProvided.subQuestions.ablationDetails}
                                        />
                                    </>
                                )}
                            </QuestionWrapper>

                            <QuestionWrapper number='c'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.medication ? 'Yes' : 'No'}
                                >
                                    Medication:
                                </Question>

                                {questions.treatmentProvided.subQuestions.medication === true && (
                                    <>
                                        <OutputDetails
                                            details={questions.treatmentProvided.subQuestions.medicationDetails}
                                        />
                                    </>
                                )}
                            </QuestionWrapper>

                            <QuestionWrapper number='d'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.other ? 'Yes' : 'No'}
                                >
                                    Other:
                                </Question>

                                {questions.treatmentProvided.subQuestions.other === true && (
                                    <>
                                        <OutputDetails
                                            details={questions.treatmentProvided.subQuestions.otherDetails}
                                        />
                                    </>
                                )}
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Please provide the outcome of most recent follow-ups, including dates and prognosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.followUps.referToAttachments}>
                        <OutputDetails
                            details={questions.followUps.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Please provide details of any ongoing limitations, restrictions and/or complications:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.ongoingRestrictions.referToAttachments}>
                        <p>{questions.ongoingRestrictions.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}
